import React, { useState } from 'react';
import { Box, Tabs, Tab, Typography, Paper } from '@mui/material';
import NotificationsTab from './NotificationsTab';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`api-health-tabpanel-${index}`}
      aria-labelledby={`api-health-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          {children}
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `api-health-tab-${index}`,
    'aria-controls': `api-health-tabpanel-${index}`,
  };
}

export default function APIHealthCheck() {
  const [value, setValue] = useState(0);

  const handleChange = (_event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: '100%', p: 3 }}>
      <Typography variant="h4" gutterBottom>
        API Health Check
      </Typography>
      <Paper sx={{ width: '100%', mb: 2 }}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs value={value} onChange={handleChange} aria-label="API health check tabs">
            <Tab label="Notifications" {...a11yProps(0)} />
            {/* Add more tabs here as needed */}
          </Tabs>
        </Box>
        <TabPanel value={value} index={0}>
          <NotificationsTab />
        </TabPanel>
        {/* Add more TabPanels here as needed */}
      </Paper>
    </Box>
  );
} 